export const Theme = {
  colors: {
    black: "#292f36",
    white: "#f7fff7",
    red: "#ff6b6b",
    teal: "#4ecdc4",
    yellow: "#ffe66d",
  },
};
